import { generateLeagueTheme } from '../utils/colorUtils';

function LeagueDisplay({ league, standings, progress, nextLeague, countdown, isLivePage }) {
  // Generate theme colors based on league name
  const themeColors = generateLeagueTheme(league?.name);

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>
          {league && !isLivePage && (
            <span
              className="league-name-badge"
              style={{ background: themeColors.badge }}
            >
              {league.name}
            </span>
          )}
        </h2>
        <div style={{ textAlign: 'right' }}>
          {nextLeague && progress !== undefined && (
            <p style={{ fontSize: '1rem', color: '#555', margin: '-15px 0 0 0' }}>
              Next up: {nextLeague.name} ({countdown}s)
            </p>
          )}
          {progress !== undefined && (
            <div style={{ height: '5px', width: '200px', backgroundColor: '#ccc', marginTop: '0.3rem' }}>
              <div
                style={{
                  height: '100%',
                  width: `${progress}%`,
                  backgroundColor: themeColors.primary,
                  transition: 'width 0.1s linear',
                }}
              />
            </div>
          )}
        </div>
      </div>

      <div
        className="standings-table-container"
        style={{
          '--league-color': themeColors.primary,
          '--league-color-light': themeColors.light,
          '--league-color-dark': themeColors.dark,
          '--league-color-rgb': themeColors.primaryRgb,
        }}
      >
        <table className="standings-table">
          <thead>
            <tr>
              <th className="position-header" title="Position">#</th>
              <th className="team-header">
                {isLivePage ? (
                  <span
                    className="league-name-badge"
                    style={{ background: themeColors.badge }}
                  >
                    {league?.name}
                  </span>
                ) : (
                  'Team'
                )}
              </th>
              <th className="stat-header" title="Games Played">P</th>
              <th className="stat-header" title="Wins">W</th>
              <th className="stat-header" title="Draws">D</th>
              <th className="stat-header" title="Losses">L</th>
              <th className="stat-header" title="Goals For">GF</th>
              <th className="stat-header" title="Goals Against">GA</th>
              <th className="stat-header" title="Goal Difference">GD</th>
              <th className="points-header" title="Points">Pts</th>
            </tr>
          </thead>
          <tbody>
            {standings.map((team, index) => (
              <tr key={team.team_id} className="standings-row">
                <td className="position-cell">
                  <span className={`position-number ${index === 0 ? 'first-place' : index === 1 ? 'second-place' : index === 2 ? 'third-place' : ''}`}>
                    {index + 1}
                  </span>
                </td>
                <td className="team-cell">
                  <span className="team-name">{team.team_name}</span>
                </td>
                <td className="stat-cell">{team.played}</td>
                <td className="stat-cell wins">{team.wins}</td>
                <td className="stat-cell draws">{team.draws}</td>
                <td className="stat-cell losses">{team.losses}</td>
                <td className="stat-cell">{team.goals_for}</td>
                <td className="stat-cell">{team.goals_against}</td>
                <td className={`stat-cell goal-difference ${team.goal_difference > 0 ? 'positive' : team.goal_difference < 0 ? 'negative' : 'neutral'}`}>
                  {team.goal_difference > 0 ? '+' : ''}{team.goal_difference}
                </td>
                <td className="points-cell">
                  <span className="points-badge">{team.points}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>


    </>
  );
}

export default LeagueDisplay;
